export default __webpack_public_path__ + "static/media/ohipcard.54c0a626.svg";